/**
 * Launch Readiness API client (M10 Phase 4).
 *
 * Fetches the executive readiness snapshot: 10 pillars scored 0–100, an
 * overall composite, and demo/checklist metadata. Used by the Launch
 * Readiness Dashboard in the Command Center suite.
 */
import { http } from "@/shared/api/http";

export interface Pillar {
  pillar: string;
  score: number;
  notes: string;
}

export interface LaunchReadinessResponse {
  overall_score: number;
  target: number;
  pillars: Pillar[];
  ready_for_launch: boolean;
  metrics?: {
    active_workspaces: number;
    active_users: number;
    ai_cost_month_usd: number;
    ai_requests_24h: number;
    queue_depth: number;
    dead_letter_24h: number;
    recent_errors: Array<{ kind: string; message: string; at: string }>;
  };
  demo_mode?: { enabled: boolean; note: string };
  go_live_checklist?: Array<{
    key: string;
    label: string;
    status: "done" | "todo" | "at_risk";
    owner: string;
  }>;
}

export async function getLaunchReadiness(): Promise<LaunchReadinessResponse> {
  return http<LaunchReadinessResponse>("/launch-readiness");
}
